<template>
  <v-stepper
    v-model="step"
    vertical
    class="mt-6 lh-2"
  >
    <div
      v-for="(q, i) in questions"
      :key="i"
    >
        <!-- :complete="step > (i + 1)" -->
      <v-stepper-step
        :step="i + 1"
        :complete="isSelected(i)"
        :id="`step${i}`"
      >
        {{ $t(`EVALUATE.${q.question}`) }}
      </v-stepper-step>

      <v-stepper-content :step="i + 1">
        {{ q.description }}

        <div>
          <FormRange
            class="my-4"
            v-if="q.component === 'range'"
            :ref="`component${i}`"
            @select="setSelected(i); next();"
          />
          <FormBool
            class="my-4"
            v-else-if="q.component === 'bool'"
            :ref="`component${i}`"
            @select="setSelected(i); next();"
          />
          <div v-else-if="q.component === 'multiple'">
            <FormMultiple
              class="my-0 py-0"
              :options="q.options"
              prefix="EVALUATE."
              :ref="`component${i}`"
              @select="setSelected(i)"
            />
            <div class="my-4 px-4 text-left">
              <v-btn
                small
                depressed
                rounded
                color="primary"
                @click="next()" :disabled="!isSelected(i)">
                  {{ $t('EVALUATE.NEXT') }}
              </v-btn>
            </div>
          </div>
          <span v-else>
            {{ q.component }}
          </span>
        </div>
      </v-stepper-content>
    </div>
  </v-stepper>
</template>

<style scoped>
.v-stepper {
  border: none;
  box-shadow: none;
  overflow-y: auto;
}
  .v-stepper--vertical .v-stepper__step {
    padding: 0;
  }
  .v-stepper--vertical .v-stepper__content {
    padding-left: 0;
    padding-right: 32px;
  }
</style>

<script type="text/javascript">
import FormBool from '@/components/form/FormBool.vue';
import FormMultiple from '@/components/form/FormMultiple.vue';
import FormRange from '@/components/form/FormRange.vue';

export default {
  name: 'FormPreWelcome',
  components: {
    FormBool,
    FormMultiple,
    FormRange,
  },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    step: 1,
    // check: false,
    selected: [],
  }),
  computed: {
    q() {
      return this.questions[this.step - 1];
    },
    canGoNext() {
      return this.selected[this.step - 1];
    },
  },
  methods: {
    component(i) {
      return (this.$refs[`component${i}`] && this.$refs[`component${i}`][0]) || {};
    },
    setSelected(i) {
      const selected = [...this.selected];
      selected[i] = true;
      this.selected = selected;

      // this.next();
    },
    isSelected(i) {
      return (i < this.selected.length);
    },
    submitStep(i) {
      const comp = this.component(i);
      const questionId = this.$store.getters['evaluate/questionId'](this.questions[i]);

      this.$store.dispatch('evaluate/submit', {
        prepost: 'pre',
        question: questionId,
        answer: comp.selected,
      });
    },
    next() {
      this.submitStep(this.step - 1);
      this.step += 1;

      // Was last question?
      if (this.step > this.questions.length) {
        this.$emit('complete');
      }

      const step = this.questions[this.step - 1];
      const cond = step && step.condition;
      if (cond) {
        let { index } = cond;
        if (index === 'prev') {
          index = this.step - 2;
        }

        const comp = this.component(index);
        if (!comp || comp.selected !== cond.value) {
          this.step += 1;
          if (this.step > this.questions.length) {
            this.$emit('complete');
          }
        }
      }

      return true;
    },
    prev() {
      if (this.step >= 0) {
        this.step -= 1;
      }
      this.scroll();
    },
  },
};
</script>
